/* Sets the app-wide country (currency, local terms) from the signed-in company: its settings when the role can read
 * them (they change as soon as the owner saves a new country), otherwise the country sent with the user. */
import type { ReactNode } from "react";
import { useSettings } from "../data/hooks";
import { countryOf } from "../domain/country";
import { CountryScope } from "../lib/country";
import { useSession } from "./session";

export function CountryProvider({ children }: { children: ReactNode }) {
  const { user, role } = useSession();
  const reads = !!user && (role === "owner" || role === "hr" || role === "accountant");
  const s = useSettings({ enabled: reads });
  const c = countryOf((reads ? s.data?.tenant.country : undefined) ?? user?.country);
  return <CountryScope country={c} global>{children}</CountryScope>;
}
